import {createDeleteMethod, createGetAllMethod, createPostMethod, createPutMethod,} from "../core/factory";
import {entityType} from "./module";

export const getAllNamespaces = () => createGetAllMethod(entityType)
export const deleteNamespace = (payload) => createDeleteMethod(entityType, payload)
export const createNamespace = (payload) => createPostMethod(entityType, payload)
export const updateNamespace = (payload) => createPutMethod(entityType, payload)
